import SessionStorage from '../helpers/sessionStorage'
import Store from '../store'

const userConsent = {

    startLoginConsentFlow(email, getProviderResult = {}) {
        const provider = getProviderResult.provider
        // if user exists for server, consent has already accepted
        const acceptConsent = 'invalidGrant' in getProviderResult
        Store.dispatch('updateLoginConsentFlow', {email, provider, acceptConsent})
    },
    acceptConsent(email, provider) {
        Store.dispatch('updateLoginConsentFlow', {email, provider, acceptConsent: true})
    },
    isRequired() {
        // return true if the user has to accept the consent on this session
        const email = SessionStorage.getItem(SessionStorage.KEYS.EMAIL)
        const loginConsentFlow = Store.getters.loginConsentFlow
        if (email === loginConsentFlow.email && loginConsentFlow.acceptConsent) {
            return false
        } else {
            return true
        }

    }

}


export default userConsent

